import { Component } from '@angular/core';
import { AccountInfo } from '@azure/msal-browser';
import { SettingsService } from '@core';
import { AuthService } from '@core/authentication/auth.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent {
  public account$: Observable<AccountInfo | null>;

  constructor(public settingsService: SettingsService, public authService: AuthService) {
    this.account$ = this.authService.getAccount();
  }

  public OnLoginClick() {
    this.authService.login();
  }

  public OnLogoutClick() {
    this.authService.logout();
  }

  public SwitchTheme() {
    this.settingsService.switchTheme();
  }
}
